/*
 * Title: Aside/index.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: Desktop Sidebar shows on Leadboard and Reward Pages
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import React from "react";
import { connect } from "react-redux";
import LinkTo from "@components/LinkTo";
import Buttonlink from "@components/Button";
import logo_letter from "@assets/logo_letter.png";
import { numberFormat } from "@helpers/common";
import CallbackService from "@services/callback-service";
import Logo from "@components/Logo";
import FullName from "@components/FullName";
import { Link } from "react-router-dom";

type Props = {};
type MyState = {};
class Aside extends React.Component<Props | any, MyState> {
  state: MyState = {};
  componentDidMount = () => {};
  render() {
    const { lifetime_points, fans_rank, total_fans_rank, points_redeemed, user } =
      this.props;
      
      const cname = this.props.creator?.creator.username
    const pname = this.props.creator?.program.name

    return (
      <div className="hidden xl:pr-20 lg:block">
        {/* desktop points stats start*/}
        <div className="space-y-5">
          <div className="bg-tile rounded-2xl py-7 space-y-5">
            <div className="text-center">
               <p className="tile-inlay-primary opacity-50 font-normal text-[16px] uppercase tracking-wider">
                POINTS AVAILABLE
              </p>
              <p className="tile-inlay-primary font-semibold text-[20px] uppercase tracking-wider">
                {numberFormat(points_redeemed)}
              </p>
            </div>
            <Link
              to={`/${cname}/${pname}/redeem`}
              className="flex items-center justify-center btn-inlay-primary font-medium lg:text-[18px] text-[16px] bg-btn  rounded-full w-[119px] h-[42px] mx-auto"
            >redeem</Link>
          </div>
          <div className="bg-tile p-5 rounded-2xl">
            <div className="h-[190px] border border-gray-700 bg-body rounded-xl p-5 flex  justify-between">
              <div className=" transition-transform duration-300 ease-in-out flex flex-col justify-end -mt-1.5 h-full">
                 <p className="tile-inlay-primary opacity-50 font-normal text-[15px] uppercase tracking-wider">
                  lifetime points
                </p>
                <h1 className="tile-inlay-primary font-medium text-[50px] leading-tight">
                  {numberFormat(lifetime_points)}
                </h1>
                <h4 className="tile-inlay-primary font-normal text-[18px] mt-5">
                  <FullName />
  
                </h4>
              </div>
              {/* <ImageIcon className="h-[60px] w-[60px]" /> */}
              <Logo
                logo_letter="true"
                className="max-h-[60px] h-full w-[auto] object-contain rounded-full"
              />
            </div>
            <div className="mt-8 text-center">
               <p className="tile-inlay-primary opacity-50 text-[15px] font-normal uppercase tracking-wider leading-7">
                Fan Rank
              </p>
              <div className="flex items-center justify-center gap-x-1">
                 <p className="tile-inlay-primary font-medium text-[16px] uppercase tracking-wider leading-7">
                  {numberFormat(fans_rank)}
                </p>
                 <div className="tile-inlay-primary opacity-50">/</div>
                <p className="tile-inlay-primary opacity-50 font-normal text-[16px] uppercase tracking-wider leading-7">
                  {numberFormat(total_fans_rank)}
                </p>
              </div>
              <LinkTo
                to={`/${cname}/${pname}/leaderboard`}
                text="View Leaderboard"
                className="uppercase font-medium text-[16px] tile-inlay-primary tracking-wider leading-7"
              />
              <div className="mt-5">
                {/* <p className="text-primary opacity-50 text-[16px] font-normal uppercase tracking-wider">
                  Points Redeemed
                </p>
                <p className="text-primary font-medium text-[20px] uppercase tracking-wider">
                  {numberFormat(lifetime_points - points_redeemed)}
                </p> */}
              </div>
            </div>
          </div>
        </div>
        {/* desktop points stats end*/}
      </div>
    );
  }
}

const mapStateToProps = ({ user, score, creator }) => {
  return {
    score: score,
    points_redeemed: score.points_redeemed,
    total_fans_rank: score.total_fans_rank,
    fans_rank: score.fans_rank,
    lifetime_points: score.lifetime_points,
    creator: creator,
    user: user.user,
  };
};

const mergeProps = (stateProps: any, dispatchProps: any) => {
  const { dispatch } = dispatchProps;
  const { actions } = require("@redux/ScoreRedux");
  return {
    ...stateProps,
    fetchScores: (programId) => {
      actions.fetchScores(dispatch, programId);
    },
  };
};

export default connect(mapStateToProps, undefined, mergeProps)(Aside);
